const MAX_LENGTH:number=32;

const IM_PATH:string="https://www.gamestolearnenglish.com/content-5/image-bank/s-140/";

export const ContentSetItem=function(props:{itemIndex:number, isFirst:boolean, showHelper:boolean, contentSetItemTextChange:(itemIndex: number, itemText: string) => void, imSrc:string, txt:string, removeItemClick:(imSrc: string) => void}){
	const imSrc=IM_PATH+props.imSrc+'.png';
	return(
		<div className="teachers-contentset-item">
			{props.isFirst && props.showHelper && (
				<div className="teachers-contentset-helper">
					<span className="teachers-contentset-helper-text">Click to edit</span>
					<span className="teachers-contentset-helper-arrow"></span>
				</div>
			)}
			<img src={imSrc} className="input here" alt="and here" width={100}/>
			<span className="teachers-contentset-item-delbit" onClick={()=>{props.removeItemClick(props.imSrc)}}></span>
			<input className="teachers-contentset-item-input" value={props.txt} type='text' maxLength={MAX_LENGTH} onChange={(e)=>{props.contentSetItemTextChange(props.itemIndex, e.target.value)}}></input>
		</div>
	)
};
